import { render, staticRenderFns } from "./otpScreen.vue?vue&type=template&id=07e6e00d"
import script from "./otpScreen.vue?vue&type=script&lang=js"
export * from "./otpScreen.vue?vue&type=script&lang=js"
import style0 from "./otpScreen.vue?vue&type=style&index=0&id=07e6e00d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports